export default __webpack_public_path__ + "static/media/vsmart_logo.e51e005e.svg";